export enum ResultUpdateType {
  ORIGINAL = 'ORIGINAL',
  MODIFIED = 'MODIFIED',
}
